import React, { memo } from 'react';
import { useStateValue } from 'context/store';
import Player from 'components/Player';

function PlayerContainer() {
  const {
    state: { player }
  } = useStateValue();
  const { song } = player;

  return song ? <Player /> : null;
}

export default memo(PlayerContainer);
